import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { UserRegistrationStep } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'userRegistrationStepDisplay',
  pure: true,
})
export class UserRegistrationStepDisplayPipe implements PipeTransform {
  transform(value: UserRegistrationStep): string {
    return CoreNiceLabelUtils.userRegistrationStep(value);
  }
}
